<script setup>
/**
 * 消耗结构环图：按流水 reason + 业务类型分块，名称见 ledger-labels.js 的 spendLabel。
 */
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import EChart from '../EChart.vue'
import { chartBase, chartTheme } from '../chart-theme.js'
import { useAdminTheme } from '../../composables/useAdminTheme.js'
import { spendLabel } from '../../pages/billing/ledger-labels.js'

const props = defineProps({
  items: { type: Array, required: true },
})
const emit = defineEmits(['select'])
const { t } = useI18n()
const { theme: themeName } = useAdminTheme()

const option = computed(() => {
  const theme = chartTheme(themeName.value)
  return {
    ...chartBase(theme),
    color: [theme.bar, theme.info, theme.success, theme.warning, theme.danger, theme.textMuted],
    tooltip: {
      ...chartBase(theme).tooltip,
      trigger: 'item',
      valueFormatter: value => Number(value).toLocaleString('en-US'),
    },
    legend: { bottom: 0, textStyle: { color: theme.textMuted } },
    series: [{
      type: 'pie',
      radius: ['45%', '72%'],
      center: ['50%', '45%'],
      itemStyle: { borderColor: theme.surface, borderWidth: 2 },
      label: { color: theme.textMuted, formatter: '{d}%' },
      data: props.items.map(item => ({ name: spendLabel(t, item), value: item.points })),
    }],
  }
})
</script>

<template>
  <EChart :option="option" height="320px" @select="emit('select', props.items[$event.index])" />
</template>
